var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"suspended-site-wrapper"},[_c('p',[_vm._v("zawaroomは現在一時停止中です。")]),_c('button',{staticClass:"zawa-button zawa-button--orange",on:{"click":function($event){return _vm.onLoginWithProvider('b2c-demo-self-asserted')}}},[_vm._v(" 管理者ログイン ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }